import rawData from "./Data/out.json";

console.log("hello");
export { rawData };
